import { Form, Formik } from "formik";
import {
  APPLY_BUTTON_STYLE,
  RESET_BUTTON_STYLE,
  getTodayEndDateTime,
} from "./reportCommon";
import { DEFAULT_RC_INNER_FILTERS } from "./staticReportData";

const RcInnerFilter = ({
  initialValues = DEFAULT_RC_INNER_FILTERS,
  siteOptions = [],
  onSearch,
  onReset,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values) => onSearch?.(values)}
    >
      {({ values, setFieldValue, resetForm, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div className="row align-items-end">
            <div className="col-md-3 mb-3">
              <label className="form-label">Vehicle No</label>
              <input
                type="text"
                name="vehicleNumber"
                value={values.vehicleNumber}
                onChange={(event) =>
                  setFieldValue("vehicleNumber", event.target.value)
                }
                className="form-control bg-white"
                placeholder="Enter vehicle no"
              />
            </div>

            <div className="col-md-3 mb-3">
              <label className="form-label">Site</label>
              <select
                name="site"
                value={values.site}
                onChange={(event) =>
                  setFieldValue("site", event.target.value)
                }
                className="form-select bg-white"
              >
                <option value="">All Sites</option>
                {siteOptions.map((station) => (
                  <option
                    key={station.transferStationId}
                    value={station.transferStationName}
                  >
                    {station.transferStationName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <label className="form-label">From Date &amp; Time</label>
              <input
                type="datetime-local"
                name="fromDateTime"
                value={values.fromDateTime}
                max={getTodayEndDateTime()}
                onChange={(event) =>
                  setFieldValue("fromDateTime", event.target.value)
                }
                className="form-control bg-white"
              />
            </div>

            <div className="col-md-3 mb-3">
              <label className="form-label">To Date &amp; Time</label>
              <input
                type="datetime-local"
                name="toDateTime"
                value={values.toDateTime}
                min={values.fromDateTime || undefined}
                max={getTodayEndDateTime()}
                onChange={(event) =>
                  setFieldValue("toDateTime", event.target.value)
                }
                className="form-control bg-white"
              />
            </div>

            <div className="col-12 mb-3 d-flex gap-2">
              <button type="submit" style={APPLY_BUTTON_STYLE}>
                APPLY FILTERS
              </button>
              <button
                type="button"
                style={RESET_BUTTON_STYLE}
                onClick={() => {
                  resetForm({ values: DEFAULT_RC_INNER_FILTERS });
                  onReset?.();
                }}
              >
                RESET
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default RcInnerFilter;
